<template>
  <div class="row flex-fill d-flex justify-content-start">
    <div class="col-md-12 mt-2 table-responsive">
      <table class="table table-borderless table-border table-align">
        <thead>
          <tr>
            <th>Versão</th>
            <th>AIT</th>
            <th>CNPJ</th>
            <th>Renavam</th>
            <th>Placa</th>
            <th>Número do Processo</th>
            <th>Status</th>
            <th>Situação</th>
            <th>Descrição</th>
            <th>Órgão consultado</th>
            <th>Data da infração</th>
            <th>Valor da multa</th>
            <th>Código da multa</th>
            <th v-for="fieldKey in customFieldKeys" :key="fieldKey" class="custom-field nowrap">
              {{ fieldKey.replace('custom_fields.', '') }}
            </th>
            <th>Modificado em</th>
            <th>Capturado em</th>
            <th>Mensagens do sistema</th>
            <th>Autor</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="history in histories" :key="history._id">
            <td>{{ history.version }}</td>
            <td>{{ history.ait }}</td>
            <td>{{ history.cnpj }}</td>
            <td>{{ history.renavam }}</td>
            <td>{{ history.placa }}</td>
            <td>{{ history.numero_processo }}</td>
            <td>{{ history.status | status }}</td>
            <td>{{ history.situacao }}</td>
            <td>{{ history.descricao }}</td>
            <td>{{ history.orgao_consultado | authority }}</td>
            <td>{{ history.ocorrido_em | datetime }}</td>
            <td>{{ history.valor_cents | price }}</td>
            <td>{{ history.codigo_multa }}</td>
            <td v-for="fieldKey in customFieldKeys" :key="fieldKey">
              {{ history[fieldKey] }}
            </td>
            <td>{{ history.updated_at | datetime }}</td>
            <td>{{ history.captured_at | datetime }}</td>
            <td>{{ formatMessages(history.messages) }}</td>
            <td>{{ showAuthor(history) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import buildItemHistory from '@/models/buildItemHistory'
import EntityProxy from '@/models/EntityProxy'
import { IssuingAuthority } from '@/models/IssuingAuthority'

export default {
  created() {
    this.find()
  },
  computed: {
    histories() {
      if (this.events.length === 0) return []
      return EntityProxy.build(buildItemHistory(this.events).reverse())
    },
    customFieldKeys() {
      const keys = new Set()

      this.histories.forEach(history => {
        Object.keys(history).forEach(key => {
          if (key.startsWith('custom_fields.'))
            keys.add(key)
        })
      })

      return Array.from(keys).sort()
    }
  },
  data: () => ({
    events: []
  }),
  methods: {
    find() {
      this.axios.v3.get(`/cm-embarcador/multas/${this.ticket.id}/events?meta=false&per_page=10000`)
        .then(response => this.events = response.data)
        .catch(e => this.$notify.addError(e))
    },
    showAuthor(history) {
      const event = this.events.find(e => e.id === history._id)
      return event.author
    },
    formatMessages(messages) {
      if (!messages) return ''

      return messages.replace(/warning:/g, 'AVISO: ')
        .replace(/error:/g, 'ERRO: ')
        .replace(/info:/g, 'INFORMAÇÃO: ')
        .replace(/;/g, '\n')
    }
  },
  filters: {
    authority(value) {
      return IssuingAuthority.label(value)
    },
    status(value) {
      return {
        '0': 'Sem status',
        '100': 'Em aberto',
        '200': 'Vencido',
        '300': 'Prescrito',
        '400': 'Sem informação',
        '500': 'Pago',
        '600': 'Cancelado',
      }[value]
    },
  },
  name: 'Events',
  props: {
    ticket: { required: true, type: Object }
  }
}
</script>

<style scoped>
.custom-field {
  color: #051B30;
}

[data-theme="dark"] .custom-field {
  color: #ffffff;
}
</style>
